import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";

const STORAGE_KEY = "nyk_partner_branding";

/**
 * Reads the `?partner=<slug>` URL param (or sessionStorage fallback) and fetches
 * the public branding payload for whitelabel deployments. Persists last-seen
 * branding so refreshes / navigation keep the look-and-feel consistent.
 *
 * Returns: { partner, primary, accent, name, logoUrl, kfsFooter, slug }
 */
export function usePartnerBranding() {
  const [searchParams] = useSearchParams();
  const slugFromUrl = (searchParams.get("partner") || "").toLowerCase().trim();
  const [partner, setPartner] = useState(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) { return null; }
  });

  useEffect(() => {
    const slug = slugFromUrl || partner?.slug || "";
    if (!slug) return;
    api.get(`/partners/by-slug/${encodeURIComponent(slug)}`)
      .then((r) => {
        setPartner(r.data);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(r.data));
      })
      .catch(() => { /* silent — partner slug may be stale */ });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugFromUrl]);

  return {
    partner,
    slug: partner?.slug || slugFromUrl || null,
    name: partner?.name || null,
    logoUrl: partner?.logo_url || null,
    primary: partner?.primary_color || null,
    accent: partner?.accent_color || null,
    kfsFooter: partner?.kfs_footer || null,
  };
}
